import * as React from 'react'

import { Box, Icon, SelectListItem, Text, useToggle } from '@factorialco/deprecated-design-system'

import { ExplotableDropdown, ExplotableItem } from 'modules/core/components/Explotable'

import type { Trigger } from 'modules/automations/store/models/Trigger'

function Illustration() {
  return (
    <Box>
      <Icon.Medium icon="play" />
    </Box>
  )
}

interface CategoryObject {
  label: string
  triggers: Trigger[]
}
interface Props {
  category: CategoryObject
  selected: Trigger | null | undefined
  setSelected: (trigger: Trigger) => void
}

const Category = ({ category, selected, setSelected }: Props) => {
  const [open, toggle] = useToggle(false)

  return (
    <ExplotableItem
      size="small"
      expandIcon="plus-minus"
      headerBorders={false}
      headerRounded={false}
      bottomRadius={false}
      dropDownAnimated={false}
      scrollLimited={false}
      opened={open}
      renderHeader={() => <Text.Header3>{category.label}</Text.Header3>}
      toggle={toggle(!open)}
    >
      <Box background="grey000White" paddingY="s16" paddingX="s32">
        <ExplotableDropdown gap="s8" open>
          {category.triggers.map((trigger) => (
            <SelectListItem
              key={trigger.get('slug')}
              label={trigger.name}
              illustration={Illustration}
              onClick={() => setSelected(trigger)}
              selected={!!selected && selected.attributes.id === trigger.get('id')}
            />
          ))}
        </ExplotableDropdown>
      </Box>
    </ExplotableItem>
  )
}

export default Category
